<template>
	<div class="phone_ayo">
		<div class="phone_ayo_people_1">
      <div class="phone_ayo_icon">
        <img src="../assets/ayo_icon.png" alt="">
      </div>
      <p v-if="lang"><span class="english">AYO! </span>音乐节</p>
      <p v-else><span class="english">AYO! Music Festival</span></p>
      <!-- AYO！音乐节 6.3 回顾视频 Start-->
      <div v-if="lang" class="phone_ayo_video">
        <div>
          <iframe frameborder="0" src="https://v.qq.com/txp/iframe/player.html?vid=d0679czvr6n" allowfullscreen></iframe>
        </div>
      </div>
      <div v-else="!lang" class="phone_ayo_video">
        <div>
        	<iframe src="https://www.youtube.com/embed/LsB70dm2Cmk" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>
        </div>
      </div>
      <p v-if="lang"><span class="english">2017.6.3 <br />AYO!</span> 音乐节回顾</p>
      <p v-else><span class="english">June 3, 2017<br /></span>AYO! Music Festival I </p>
      <!-- AYO！音乐节 6.3 回顾视频 End-->

      <!-- AYO！音乐节 2017.10.1-3 回顾视频 Start-->
      <div v-if="lang" class="phone_ayo_video">
        <div>
          <iframe frameborder="0" src="https://v.qq.com/txp/iframe/player.html?vid=l0636yz5pje" allowfullscreen></iframe>
        </div>
      </div>
      <div v-else="!lang" class="phone_ayo_video">
        <div><iframe src="https://www.youtube.com/embed/RThWS8MPaH8" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe></div>
      </div>
      <p v-if="lang"><span class="english">2017.10.1-3 <br />AYO!</span> 音乐节回顾</p>
      <p v-else><span class="english">October 1st-3rd, 2017<br />AYO! Music Festival II </span></p>
      <!-- AYO！音乐节 2017.10.1-3 回顾视频 End-->

      <!-- AYO！音乐节 2018 苏州 回顾视频 Start-->
      <div v-if="lang" class="phone_ayo_video">
        <div>
          <iframe frameborder="0" src="https://v.qq.com/txp/iframe/player.html?vid=l0706kkaw85" allowfullscreen></iframe>
        </div>
      </div>
      <div v-else="!lang" class="phone_ayo_video">
        <div><iframe src="https://www.youtube.com/embed/ZUw-g7OBNnk" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe></div>
      </div>
      <p v-if="lang"><span class="english">2018 苏州站<br />AYO!</span> 音乐节回顾</p>
      <p v-else><span class="english">Suzhou 2018 <br />AYO! Music Festival</span></p>
      <!-- AYO！音乐节 2018 苏州 回顾视频 End-->
    </div>
    <div class="phone_ayo_people">
  		<p v-if="lang"><span class="english">AYO! </span>往期合作艺人</p>
      <p v-else><span class="english">AYO! Cooperated artists</span></p>
  		<div class="phone_ayo_people_card">
       	  <img class="" src="../assets/card/Fetty_Wap.jpg" alt="">
	      <img src="../assets/card/OG_Maco.jpg" alt="">
	      <img src="../assets/card/Honey_Cocaine.jpg" alt="">
	      <img class="" src="../assets/card/Soulja_Boy.jpg" alt="">
	      <img src="../assets/card/Robb_Bank$.jpg" alt="">
	      <img src="../assets/card/KOHH.jpg" alt="">
          <img src="../assets/card/dax.jpg" alt="">
          <img src="../assets/card/gai.jpg" alt="">
          <img src="../assets/card/Tizzy-T.jpg" alt="">
          <img src="../assets/card/Jony-J.jpg" alt="">
          <img src="../assets/card/Higher Brothers.jpg" alt="">
          <img src="../assets/card/OMENXIII.jpg" alt="">
	      <img src="../assets/card/VAVA.jpg" alt="">
	      <img src="../assets/card/Bridge.jpg" alt="">
	      <img src="../assets/card/Afjn.jpg" alt="">
	      <img src="../assets/card/Hx.jpg" alt="">
          <img src="../assets/card/MJ116.jpg" alt="">
          <img src="../assets/card/hhh.jpg" alt="">
          <img src="../assets/card/pg one.jpg" alt="">
	      <img src="../assets/card/Hhhbb.jpg" alt="">
	      <img src="../assets/card/C-Block.jpg" alt="">
	      <img src="../assets/card/Msk.jpg" alt="">
	      <img src="../assets/card/TY.jpg" alt="">
	      <img src="../assets/card/Al_Rocco.jpg" alt="">
	      <img src="../assets/card/Bbno$.jpg" alt="">
	      <img src="../assets/card/Akj-akin.jpg" alt="">
          <img src="../assets/card/Fl-Pharaoh.jpg" alt="">
          <img src="../assets/card/yitai.jpg" alt="">
          <img src="../assets/card/Jellorio.jpg" alt="">
	      <img src="../assets/card/buzzy.jpg" alt="">
          <img src="../assets/card/Guibian.jpg" alt="">
          <img src="../assets/card/pact.jpg" alt="">
          <img src="../assets/card/xinba.jpg" alt="">
	      <img src="../assets/card/Fcyco.jpg" alt="">
	      <img src="../assets/card/Yee.jpg" alt="">
          <img src="../assets/card/Sio.jpg" alt="">
	      <img src="../assets/card/Yls.jpg" alt="">
	      <img src="../assets/card/TOY.jpg" alt="">
	      <img src="../assets/card/ONO.jpg" alt="">
	      <img src="../assets/card/Dbz-Dabozz.jpg" alt="">
	      <img src="../assets/card/WyPavel.jpg" alt="">
          <img src="../assets/card/sexy slippers.jpg" alt="">
	      <img src="../assets/card/Young_Queenz.jpg" alt="">
	      <img src="../assets/card/Htlq.jpg" alt="">
	      <img src="../assets/card/LxnGali.jpg" alt="">
	      <img src="../assets/card/Lil_Jet.jpg" alt="">
          <img src="../assets/card/xzz.jpg" alt="">
	      <img src="../assets/card/Kozay.jpg" alt="">
	      <img src="../assets/card/gali.jpg" alt="">
	      <img src="../assets/card/Ha$.jpg" alt="">
	      <img src="../assets/card/Zhb.jpg" alt="">
          <img src="../assets/card/Dx.jpg" alt="">
          <img src="../assets/card/kc.jpg" alt="">
          <img src="../assets/card/Fi9jiangche.jpg" alt="">
	      <img src="../assets/card/Wsy.jpg" alt="">
	      <img src="../assets/card/Jark_StickJcy.jpg" alt="">
          <img src="../assets/card/PRCbayinhan.jpg" alt="">
          <img src="../assets/card/young gee.jpg" alt="">
          <img src="../assets/card/cde.jpg" alt="">
          <img src="../assets/card/eTong.jpg" alt="">
          <img src="../assets/card/nine one.jpg" alt="">
          <img src="../assets/card/LAZY-AIR.jpg" alt="">
          <img src="../assets/card/doudou.jpg" alt="">
          <img src="../assets/card/Danengren.jpg" alt="">
          <img src="../assets/card/two-J.jpg" alt="">
          <img src="../assets/card/Wj.jpg" alt="">
          <img src="../assets/card/Dirty-Twinz.jpg" alt="">
          <img src="../assets/card/Big_Daddy.jpg" alt="">
  		</div>
  	</div>
  	<div id="ayo_people_2" class="phone_ayo_people_2">
      <div>
        <img src="../assets/card_logo_1.png" alt="">
      </div>
      <div>
        <p><span class="english">“YOUNG WILD FREE”</span></p>
        <p v-if="lang">
          <span class="english">AYO!</span>旗下打造的“<span class="english">AYO!</span>音乐节”是中国首个嘻哈音乐节，已成功举办2界，是目前国内最大型的嘻哈音乐节
        </p>
        <p v-else>
          <span class="english">"AYO! Music Festival" is the first hip-hop music festival in China. It has been successfully held for 2 times. It is the largest hip-hop festival in China.</span>
        </p>
      </div>
    </div>
    <div class="phone_ayo_people_3">
			<p v-if="lang">派嗨拜浪 ( 上海 ) 网络科技有限公司版权所有<br />©2016【 沪ICP备16032276号 】</p>
	    <p v-else class="english">PAIHAIBAILANG (SHANGHAI) NETWORK TECHNOLOGY CO., LTD. All rights reserved<br />©2016[Shanghai ICP no. 16032276]</p>
	    <p v-if="lang">本网站由派嗨拜浪 ( 上海 ) 网络科技有限公司提供</p>
	    <p v-else class="english">This website is provided by PAIHAIBAILANG (SHANGHAI) NETWORK TECHNOLOGY CO., LTD</p>
		</div>
	</div>
</template>

<script>
	export default {
  	props:["lang"],
	  data () {
	    return {
	      msg: '11'
	    }
	  },
	  mounted () {
	  	if(document.getElementById('phoneayo_icon')) {
	  		document.getElementById('phoneayo_icon').style.display = "none";
		    document.getElementById('phoneayo_icon_2').style.display = "inline-block";
		    document.getElementById('phoneafsc_icon').style.display = "inline-block";
		    document.getElementById('phoneafsc_icon_2').style.display = "none";
	  		console.log(document.getElementById('phoneayo_icon'))
	  	}else {
	  		setTimeout(() => {
          document.getElementById('phoneayo_icon').style.display = "none";
			    document.getElementById('phoneayo_icon_2').style.display = "inline-block";
			    document.getElementById('phoneafsc_icon').style.display = "inline-block";
			    document.getElementById('phoneafsc_icon_2').style.display = "none";
        },1);
	  	}
//	    document.getElementById('phoneayo_icon').style.display = "none";
//	    document.getElementById('phoneayo_icon_2').style.display = "inline-block";
//	    document.getElementById('phoneafsc_icon').style.display = "inline-block";
//	    document.getElementById('phoneafsc_icon_2').style.display = "none";
	  },
	  activated() {
	  	console.log(1111)
	  	console.log(document.getElementById('phoneayo_icon'));
	  	document.getElementById('phoneayo_icon').style.display = "none";
	    document.getElementById('phoneayo_icon_2').style.display = "inline-block";
	    document.getElementById('phoneafsc_icon').style.display = "inline-block";
	    document.getElementById('phoneafsc_icon_2').style.display = "none";
	  }
	}
</script>

<style lang="less" scoped>
	.phone_ayo {
		width: 100%;
	}
	.phone_ayo_people_1 {
		width: 100%;
		background-color: #000000;
		color: #FFFB00;
		padding-top: 6rem;
		padding-bottom: .1rem;
		p {
			color: #FFFB00;
			padding-top: 3rem;
			margin: 0;
			padding-bottom: 3rem;
			font-family: Heavy;
			font-size: 1.6rem;
			text-align: center;
			letter-spacing: 0.15rem;
			font-weight: bold;
		}
		&>p:nth-child(n+3) {
			width: 17rem;
			font-size: 1.2rem;
			text-align: left;
			margin: 0 auto;
			padding: .5rem 0 2rem 0;
		}
	}
	
	.phone_ayo_icon {
		width: 100%;
		img {
			width: 30%;
		}
	}
	
	.phone_ayo_video div iframe{
		width: 17rem;
		border: .5rem solid #FFFC01;
	}
	
	.phone_ayo_people {
		background-color: #000000;
		p {
			color: #FFFB00;
			padding-top: 3rem;
			margin: 0;
			padding-bottom: 3rem;
			font-family: Heavy;
			font-size: 1.6rem;
			text-align: center;
			letter-spacing: 0.15rem;
			font-weight: bold;
		}
	}
	
	.phone_ayo_people_card {
		width: 70%;
		margin: 0 auto;
		font-size: 0;
		text-align: center;
    padding-bottom: 60px;
		img {
      display: inline-block;
			vertical-align: top;
			width: 45%;
			margin-right: 10%;
			padding-bottom: 2rem;
      transition: 0.5s all;
      &:hover {
        transform: scale(1.3);
      }
		}
		&>img:nth-child(2n) {
			margin-right: 0;
		}
	}
	.phone_ayo_people_2 {
    width: 100%;
    background-color: #FFFB00;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 6rem 1rem 6rem 0rem;
    &>div:nth-child(1) {
    	width: 7rem;
    	margin-right: 1rem;
    }
    img {
    	width: 100%;
    }
    &>div:nth-child(2) {
      width: 10rem;
      text-align: left;
      color: #000000;
      &>p:first-child { 
				font-size: 1.2rem;
        margin-bottom: 1rem;
      }
      &>p:nth-child(n+2) {
        font-size: .8rem;
				letter-spacing: 0.15rem;
        text-align:justify;
        font-family: Regular;
	      .english {
	      	letter-spacing: 0.01rem;
	      }
      }
    }
  }
  .phone_ayo_people_3 {
		width: 100%;
		background-color: #FFFB00;
		padding: 0rem 0rem 2rem 0rem ;
		p {
			width: 96%;
			margin: 0 auto;
			color: #000000;
			font-family: Regular;
			font-size: .8rem;
			text-align: center;
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/phone_AYO.vue